import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface PaymentCountdownProps {
  deadline: string // ISO 8601 timestamp
  onExpired?: () => void
}

const formatTime = (ms: number): string => {
  if (ms <= 0) return '00:00:00'
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0'
  )}:${String(seconds).padStart(2, '0')}`
}

const PaymentCountdown = ({ deadline, onExpired }: PaymentCountdownProps) => {
  const [remaining, setRemaining] = useState<number>(
    () => new Date(deadline).getTime() - Date.now()
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const timeLeft = new Date(deadline).getTime() - Date.now()
      setRemaining(timeLeft)

      if (timeLeft <= 0) {
        clearInterval(interval)
        onExpired?.()
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [deadline, onExpired])

  if (remaining <= 0) {
    return (
      <Box>
        <Typography color='error' variant='body1' fontWeight='bold'>
          Payment window expired
        </Typography>
      </Box>
    )
  }

  const isUrgent = remaining < 3_600_000 // less than 1 hour

  return (
    <Box>
      <Typography
        color={isUrgent ? 'error' : 'text.primary'}
        variant='body1'
        fontWeight={isUrgent ? 'bold' : 'normal'}
      >
        {formatTime(remaining)} remaining
      </Typography>
    </Box>
  )
}

export default PaymentCountdown
